import { STATUS_SHOP_ORDERS, TAB_SHOP_ORDERS } from 'components/pages/shop-orders/base/enumsShopOrders';
import { template } from 'utils/helper';

export const url_store = {
	products: 'store/products/',
	update_store_order: template`store/update-store-orders/${'slug'}/`,
	create_store_order: 'store/create-store-order/',
	change_status: 'store/change-status/',
	store_orders: 'store/store-orders/',
	store_order: template`store/store-orders/${'slug'}/`
};

const getParams = ({ page, rowsPerPage, sortParameter, isOrderByAsc, values, searchParameter }) => {
	const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;

	const pagination = Object.assign({},
		order && { o: order },
		rowsPerPage && { pageSize: rowsPerPage },
		page && { page: page + 1 }
	);

	const cpValues = { ...values };
	delete cpValues.month;
	delete cpValues.year;
	delete cpValues.isPaid;
	const formValues = Object.assign(cpValues,
		values?.month && { month: values?.month },
		values?.year && { year: values?.year }
	);

	const otherParams = Object.assign({},
		searchParameter && { q: searchParameter }
	);

	return {
		...pagination,
		...formValues,
		...otherParams
	};
};

const store = service => ({
	updateStoreOrder: ({ slug, values }) => service.patch(url_store.update_store_order({ slug }), values),
	getProductsVariants: () => service.get(url_store.products),
	createOrder: ({ items, address }) => service.post(url_store.create_store_order, {
		items,
		...address
	}),
	changeStatus: ({ ids, status }) => service.put(url_store.change_status, {
		storeOrders: ids,
		status
	}),
	getShopOrders: ({ currentTab, page, rowsPerPage, sortParameter, isOrderByAsc, values, searchParameter }) => {
		const filters = {
			[TAB_SHOP_ORDERS.ALL]: {},
			[TAB_SHOP_ORDERS.CREATED]: { status: STATUS_SHOP_ORDERS.CREATED },
			[TAB_SHOP_ORDERS.IN_REALIZATION]: { status: STATUS_SHOP_ORDERS.IN_REALIZATION },
			[TAB_SHOP_ORDERS.CANCELED]: { status: STATUS_SHOP_ORDERS.CANCELED },
			[TAB_SHOP_ORDERS.REALIZED]: { status: STATUS_SHOP_ORDERS.REALIZED }
		};

		return service.get(url_store.store_orders, {
			params: {
				...getParams({ page, rowsPerPage, sortParameter, isOrderByAsc, values, searchParameter }),
				...filters[currentTab]
			}
		});
	},
	getShopOrder: ({ slug }) => service.get(url_store.store_order({ slug }))
});

export default store;
